module.exports = "../img/Liniers-Vertical.jpg";


//////////////////
// WEBPACK FOOTER
// ./Statics/img/Liniers-Vertical.jpg
// module id = 35
// module chunks = 0